module.exports = __webpack_public_path__ + "img/portfolio-big-09.ceff1593.png";